import React, { useState, useEffect, useMemo } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import "./SpeechBot.css"; // <-- Make sure to create this file
import useTranslation from '../hooks/useTranslation';

const MONSTER_IMAGES = [
    "/monster1.png",
    "/monster2.png",
    "/monster3.png",
    
];

export default function SpeechBot({ onCommand, onRequireLogin }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [showBubble, setShowBubble] = useState(true);
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  // 👾 Pick a random monster on mount
  const randomMonsterImg = useMemo(() => {
    return MONSTER_IMAGES[Math.floor(Math.random() * MONSTER_IMAGES.length)];
  }, []);

  // Hide bubble after first interaction or after 3 seconds
  useEffect(() => {
    if (open || listening) setShowBubble(false);
    else {
      const t = setTimeout(() => setShowBubble(false), 10000);
      return () => clearTimeout(t);
    }
  }, [open, listening]);

  useEffect(() => {
    if (!listening && transcript && open) {
      onCommand(transcript);
      setOpen(false);
      resetTranscript();
    }
  }, [listening, transcript, onCommand, open, resetTranscript]);

  if (!browserSupportsSpeechRecognition) return null;

  return (
    <div style={{ position: "fixed", bottom: 32, right: 32, zIndex: 9999 }}>
      {/* Speech Bubble */}
      {showBubble && (
        <div className="speech-bubble cloud-animate">
          <span>👋 {t('Speak to me!')}</span>
        </div>
      )}

      {/* Monster button */}
      <button
        className="speech-bot-btn monster-animate"
        onClick={() => {
//loacal
          if (!localStorage.getItem("neuro_user_id")) {
            if (typeof onRequireLogin === "function") onRequireLogin();
            return;
          }

          setOpen(true);
          SpeechRecognition.startListening({ continuous: false });
        }}
        aria-label={t('Speak to Bot')}
      >
        <img
          src={randomMonsterImg}
          alt={t('Monster Bot')}
          className="monster-img"
        />
        {listening && <span className="listening-blink">{t('Listening...')}</span>}
      </button>
    </div>
  );
}
